// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"88":"browse","270":"my-favourites","499":"my-sessions","596":"404","922":"edit"}[chunkId] || chunkId) + "." + {"88":"5694e000","123":"21a51bc3","270":"4bfb3624","499":"54a7b930","596":"ac25a02c","895":"2ec3c8af","922":"e968b9bd"}[chunkId] + ".css";
};